// extracted by mini-css-extract-plugin
export var alt = "GalleryModal-module--alt--8e748";
export var desktopOnly = "GalleryModal-module--desktopOnly--033e3";
export var main = "GalleryModal-module--main--64698";
export var mobileOnly = "GalleryModal-module--mobileOnly--bb60d";
export var styledModal = "GalleryModal-module--styledModal--fb797";
export var textLeft = "GalleryModal-module--textLeft--d2da4";
export var visuallyHidden = "GalleryModal-module--visuallyHidden--8980a";